import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

 ibgeEndPoint: string = environment.IBGEApi;
 ibgeEndPointMunicipios: string = environment.IBGEApiMunicipios;

  constructor(private httpClient: HttpClient) { }

  getEstados(): Observable<any> {
    const endpoint = `${this.ibgeEndPoint}`;
    return this.httpClient.get(endpoint).pipe();
  }

  getMunicipiosPorUf(UF: string): Observable<any> {
    const endpoint = `${this.ibgeEndPoint}${UF}/municipios`;
    return this.httpClient.get(endpoint).pipe();
  }

  getMunicipiosPorMunicipioId(id: string): Observable<any> {
    const endpoint = `${this.ibgeEndPointMunicipios}${id}`;
    return this.httpClient.get(endpoint).pipe();
  }
}

